import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Heading } from 'components/Heading'
import { BillingMenuItem } from './BillingMenuItem'
import { Stack } from 'components/Stack'
import styles from './BillingMenu.module.scss'

export const BillingMenu: FC = (_props) => {
  const { t } = useTranslation()

  return (
    <Stack className={styles.billingMenu}>
      <Heading align="right">{t('billing.heading')}</Heading>
      <nav>
        <Stack component="ul" space="medium">
          <BillingMenuItem path="/billing" text={t('billing.menu.subscription')} />
          <BillingMenuItem path="/billing/addons" text={t('billing.menu.addons')} />
          <BillingMenuItem path="/billing/invoices" text={t('billing.menu.invoices')} />
        </Stack>
      </nav>
    </Stack>
  )
}

BillingMenu.displayName = 'BillingMenu'
